import React from "react";
import { useSelector } from "react-redux";
import kumbhImage from '../dashboard.jpg'; // Import the image

const Welcome = () => {
  const { user } = useSelector((state) => state.auth);
  return (
    <div className="dashboard-image">
      <img src={kumbhImage} alt="Welcome Image" />
      <div className="text-overlay">
        <h1 className="title">WELCOME</h1>
        <h2 className="subtitle">
          TO MAHA KUMBH FESTIVAL
        </h2>
      </div>
    </div>
  );
};

export default Welcome;
